module.exports = __webpack_public_path__ + "img/jam_linkedin-circle.9151422b.svg";